// src/main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";
import Vue3Marquee from "vue3-marquee";
import Aura from "@primeuix/themes/aura";
import "primeflex/primeflex.css"; // optional layout utilities

// createApp(App).use(router).use(PrimeVue).use(Vue3Marquee).mount('#app');
const app = createApp(App);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
  },
});

app.use(router);
app.use(Vue3Marquee);

// Finally mount the app
app.mount("#app");
